import $ from 'jquery';
import { closeModal } from '@/functions/function.js';

export default {
    name: 'fournisseurs',
    components: {},
    props: [],
    data () {
      return {
          fields: ['nom','telephone','adresse', 'actions'],
          filter: "",
          loading: false,
          perPage: 15,
          currentPage: 1,
          fournisseur: {},
      }
    },
    computed: {
      fournisseurs() {
          return this.$store.getters['fournisseurs']
      },
  
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

      this.$store.dispatch("getFournisseurs");
    },
    methods: {
        setFournisseur(data) {
            this.$set(this.fournisseur, 'id', data.id)
            this.$set(this.fournisseur, 'adresse', data.adresse)
            this.$set(this.fournisseur, 'telephone', data.telephone)
            this.$set(this.fournisseur, 'nom', data.nom)
        },
        deleteFournisseur() {
            this.$store.dispatch("deleteFournisseur", this.fournisseur.id);
            this.$refs.close_delete.click()
        },

        async updateFournisseur() {
            this.loading=true
            const data = {
                nom:  this.fournisseur.nom,
                telephone:  this.fournisseur.telephone,
                adresse:  this.fournisseur.adresse,
            }   
    
            await this.$store.dispatch("editFournisseur",{ 
                id:this.fournisseur.id , 
                data: data 
            }).then(
                response => {
    
                    if (response) {
                        this.$refs.close_update.click()
                        this.loading=false
                    } 
                }
            );
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }
        
    }

  }
  
  
  